import { User } from './user.entity';

export interface SessionProps {
  user: User;
  token: string;
}

export class Session {
  private readonly _user: User;
  private readonly _token: string;

  constructor(props: SessionProps) {
    if (!props.token || props.token.trim().length === 0) {
      throw new Error('El token de sesión no puede estar vacío');
    }
    this._user = props.user;
    this._token = props.token;
  }

  public get user(): User {
    return this._user;
  }

  public get token(): string {
    return this._token;
  }

  public toJSON(): { user: { id: string; email: string }; token: string } {
    return {
      user: this._user.toJSON(),
      token: this._token,
    };
  }
}
